import React from "react";


export default function Overlay(props) {
  return <div id={props.id} className="ds-overlay">{props.children}</div>
}


/*

Usage:

<Overlay id=""></Overlay>

- id (Optional): String

*/